import { Chart as ChartJS, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Ensure all default controllers/elements/scales are registered once globally
// This prevents runtime errors like: "line is not a registered controller"
ChartJS.register(...registerables, ChartDataLabels);


